import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import DesignPartnerDialog from "../components/argus/DesignPartnerDialog";
import { Button } from "../components/ui/button";
import { INDUSTRIES } from "../lib/marketingContent";

export default function Industry() {
  const { slug } = useParams();
  const i = INDUSTRIES[slug];
  if (!i) return <Navigate to="/" replace />;

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="mx-auto max-w-6xl w-full px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <p className="text-xs uppercase tracking-wider text-gold mb-3 font-semibold">For {i.name}</p>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight max-w-3xl" data-testid="industry-title">{i.tagline}</h1>
        <p className="mt-6 text-lg text-ink/70 max-w-2xl">{i.summary}</p>

        <div className="mt-10 rounded-xl border border-line bg-panel p-6 flex items-start gap-3 max-w-2xl" data-testid="industry-proof">
          <ShieldCheck className="text-safe shrink-0 mt-0.5" />
          <p className="text-ink/80">{i.proof}</p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/signup">
            <Button className="bg-gold text-paper hover:bg-gold2 h-12 px-6 font-semibold" data-testid="industry-cta">
              Start My Free Scan <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
          <DesignPartnerDialog
            source={`industry-${slug}`}
            trigger={
              <Button variant="outline" className="h-12 px-6 border-line bg-transparent text-ink hover:bg-raised" data-testid="industry-talk">
                Talk to Security
              </Button>
            }
          />
        </div>
      </section>
      <Footer />
    </div>
  );
}
